export var ColumnFormat;
(function (ColumnFormat) {
    ColumnFormat["PHONE_NUMBER"] = "PHONE_NUMBER";
    ColumnFormat["PHONE_NUMBER_STATUS"] = "PHONE_NUMBER_STATUS";
})(ColumnFormat || (ColumnFormat = {}));
function isColumnFormat(format) {
    if (format === undefined) {
        return false;
    }
    return Object.values(ColumnFormat).includes(format);
}
export const MIN_COLUMN_WIDTH = 40;
export function getColumnWidth(fieldName, format, maxWidth, userWidth) {
    const baseWidth = userWidth ??
        defaultColumnsWidth.byName[fieldName] ??
        (isColumnFormat(format) ? defaultColumnsWidth.byFormat[format] : undefined) ??
        maxWidth;
    if (typeof baseWidth === 'number' && baseWidth < MIN_COLUMN_WIDTH) {
        return MIN_COLUMN_WIDTH;
    }
    return baseWidth;
}
// Central place for built-in column width defaults used by table header & body.
export const defaultColumnsWidth = {
    byName: {
        index: 40,
        Database: 100,
    },
    byFormat: {
        [ColumnFormat.PHONE_NUMBER]: 140,
        [ColumnFormat.PHONE_NUMBER_STATUS]: 70,
    },
};
//# sourceMappingURL=defaultColumnsWidth.js.map